<template>
  <div class="set">
    <van-nav-bar
      :title="$t('m.yuyan')"
      @click-left="onClickLeft"
      left-arrow
    ></van-nav-bar>
    <div style="padding:10px 0;background:#f5f5f5;margin-top:0px;font-size:15px;">
        <div @click="xuan(0)" style=" display:flex;align-items:center;height: 55px;justify-content: space-between;background:#fff;padding:0 14px;border-bottom:1px solid #eee;">
            <span :style="{color:index==0?'#CDA569':'#000'}">简体中文</span>
            <img v-if="index==0" src="../../assets/images/new/duihao.png" style="width: 20px;height: 20px;" alt="">
        </div>
        <div @click="xuan(1)" style="display:flex;align-items:center;height: 55px;justify-content: space-between;background:#fff;padding:0 14px;border-bottom:1px solid #eee;">
            <span :style="{color:index==1?'#CDA569':'#000'}">English</span>
            <img v-if="index==1" src="../../assets/images/new/duihao.png" style="width: 20px;height: 20px;" alt="">
        </div>
    </div>
  </div>
</template>

<script>
import { getMyUserInfo } from "@api/user";
import local from "@/utils/local";
export default {
  data() {
    return {
      index:0,
    };
  },
  created() {
    let yy = this.$i18n.locale
                 console.log(yy)
                 if (yy=="en-US") {
                     this.index = 1;
                  
                 }else{
                     this.index = 0;
                  
                 }
  },
  methods: {
      xuan(e){
          this.index = e;
            if (e == 0) {
                
        this.$i18n.locale = 'zh-CN'
                   localStorage.setItem('lang', "zh-CN")
      } else if (e == 1) {
         this.$i18n.locale = 'en-US'
                   localStorage.setItem('lang', "en-US")
      }
      },
    dianji(e) {
      if (e == 0) {
        this.$router.push({
          path: "/PayPass"
        });
      } else if (e == 1) {
        this.$router.push({
          path: "/LoginPass"
        });
      } else if (e == 2) {
        this.$dialog.message("清理完毕");
      } else if (e == 3) {
        this.$store.commit("LOGOUT");
        let usernames = window.localStorage.getItem("zhanghao");
        let passwords = window.localStorage.getItem("mima");
        let fwq = window.localStorage.getItem("fwq");

        local.clear();
        window.localStorage.setItem("zhanghao", usernames);
        window.localStorage.setItem("mima", passwords);
        window.localStorage.setItem("fwq", fwq);

        this.$router.push({
          path: `/login`
        });
      }
    },
    onClickLeft() {
      this.$router.go(-1);
    }
  },
  components: {}
};
</script>
<style scoped lang="less">
.register_submit {
  width: 92%;
  margin: 0 auto;
  height: 50px;
  background: #CDA569;
  border-radius: 5px;
  margin-top: 20px !important;
  text-align: center;
  line-height: 50px;
  color: #ffffff;
  font-size: 16px;
}
.teamindeximg {
  width: 100%;
}

.teamtitle {
  background-color: #f6f6fe;
  font-size: 15px;
  display: flex;
  padding: 10px;
  box-sizing: border-box;
  align-items: center;
  width: calc(100% - 12px);
}

.teamnum {
  background-color: #067594;
  color: #fff;
  padding: 0 8px;
  border-radius: 20px;
  margin-left: 3px;
  font-size: 13px;
  height: 18px;
  line-height: 20px;
}

.teamli {
  border-bottom: 1px solid #f6f6f6;
  padding: 7px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;

  font-size: 15px;
}

.teamlist {
  padding-right: 12px;
}

.teamlil {
  display: flex;
  align-items: center;
}

.teamlil img {
  width: 50px;
  height: 50px;
  object-fit: cover;
  border-radius: 100%;
  margin-right: 20px;
}
/deep/ .van-nav-bar .van-icon {
  color: #333;
}

/deep/ #all {
  width: 780px;
  padding: 100px 32px;
  background: #fff;
}
</style>
